import React from 'react';
import PropTypes from 'prop-types';

import { STRING_FIELD_EDUCATION_DEGREE_YEAR } from '../labels';

import FormikLabeledField from './FormikLabeledField';
import YearOptions from '../YearOptions';

import formikPropTypes from './formikPropTypes';

export function DegreeEndYearField({
  name, formikProps,
}) {
  return (
    <FormikLabeledField
      as="select"
      formikProps={formikProps}
      name={name}
      label={STRING_FIELD_EDUCATION_DEGREE_YEAR}
      placeholder={STRING_FIELD_EDUCATION_DEGREE_YEAR}
    >
      <YearOptions />
    </FormikLabeledField>
  );
}

DegreeEndYearField.propTypes = {
  name: PropTypes.string.isRequired,
  formikProps: formikPropTypes.isRequired,
};

export default DegreeEndYearField;
